import { render, staticRenderFns } from "./PaidRequests.vue?vue&type=template&id=27a0289f&scoped=true&"
import script from "./PaidRequests.vue?vue&type=script&lang=js&"
export * from "./PaidRequests.vue?vue&type=script&lang=js&"
import style0 from "./PaidRequests.vue?vue&type=style&index=0&id=27a0289f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a0289f",
  null
  
)

export default component.exports